import { render, staticRenderFns } from "./MyCollectionCategory.vue?vue&type=template&id=3ad4195f&scoped=true"
import script from "./MyCollectionCategory.vue?vue&type=script&lang=js"
export * from "./MyCollectionCategory.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionCategory.vue?vue&type=style&index=0&id=3ad4195f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4195f",
  null
  
)

export default component.exports